/**
 * Frontend feature flags, read from Vite env. Mirrors the `VITE_EUCHRE_FAKE_AUTH`
 * pattern used by the auth store and router.
 */
function parseFlag(value: string | undefined): boolean {
  if (!value) return false
  const normalized = value.trim().toLowerCase()
  return normalized === '1' || normalized === 'true' || normalized === 'yes'
}

/**
 * Competitive surfaces (Rankings, Tournaments, and the ranked bits of the lobby) ship
 * behind this flag so they can roll out dark while Home/About/Pricing default on.
 * See `08-marketing-and-product-pages.md` §4.
 */
export const competitiveEnabled = parseFlag(import.meta.env.VITE_EUCHRE_COMPETITIVE)
